var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[(_vm.title)?_c('h3',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }